import {ResearchLitElement, html, css} from '@core/research-lit-element';
import '@bog-design-system/bd-font';

import '../../../common/layout/research-section.js';
import '../../../common/research-product-promo-card.js';

class researchStageSection extends ResearchLitElement {
    static get is() {
        return 'research-stage-section';
    }

    static get styles() {
        return css`
            .stage-title-highlight,
            .stage-desc {
                color: var(--color-invert-component-tr-30);
            }

            .stage-title {
                color: var(--color-secondary-solid-10);
            }

            .stage-section {
                padding-top: var(--space-96);
                padding-bottom: var(--space-80);
            }

            .stage-container {
                display: flex;
                column-gap: var(--space-24);
                justify-content: space-between;
            }
    
            .stage-text-container {
                max-width: 486px;
                display: flex;
                flex-direction: column;
                row-gap: var(--space-24);
            }

            .stage-title {
                word-wrap: break-word;
            }

            .stage-cards-container {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-column-gap: var(--space-72);
                grid-row-gap: var(--space-80);
            }
    
            .stage-card {
                --card-width: 294px;
                --img-width: 137px;
                --img-height: 102px;
                --card-padding: 0;
                --img-margin-v: var(--space-16);
                --card-border-radius: unset;
                --card-border: unset;
            }

            @media (max-width: 1024px) {
                .stage-text-container {
                    max-width: 347px;
                }

                .stage-cards-container {
                    grid-column-gap: var(--space-32);
                }
    
                .stage-card {
                    --card-width: 254px;
                }
            }

            @media (max-width: 768px) {
                .stage-section {
                    padding-top: var(--space-64);
                    padding-bottom: var(--space-48);
                }
                
                .stage-container {
                    flex-direction: column;
                    row-gap: var(--space-32);
                }
    
                .stage-text-container {
                    max-width: unset;
                    row-gap: var(--space-12);
                }
    
                .stage-title,
                .stage-desc {
                    text-align: center;
                }
    
                .stage-cards-container {
                    grid-template-columns: repeat(1, 1fr);
                    grid-row-gap: var(--space-32);
                    padding: 0 var(--space-40);
                }
    
                .stage-card {
                    --card-container-align: center;
                    --img-width: 150px;
                    --img-height: 112px;
                }
            }

            @media (max-width: 600px) {
                .stage-section {
                    padding-bottom: var(--space-32);
                }

                .stage-container {
                    row-gap: var(--space-24);
                }
                
                .stage-text-container {
                    row-gap: var(--space-16);
                }
    
                .stage-cards-container {
                    padding: 0;
                }
    
                .stage-card {
                    --img-width: var(--space-80);
                    --img-height: calc(var(--space-48) + var(--space-12));
                    --card-horizontal-description: block;
                    min-height: 128px;
                }

                .stage-card-title {
                    margin-bottom: var(--space-8);
                }
                
                .stage-card-description {
                  margin-bottom: 0px;
                }
            }
        `;
    }

    render() {
        return html`
            ${this.data?.title &&
        this.data.titleHighlight &&
        this.data.cards?.length > 0 ?
            html`
                <research-section class="stage-section">
                    <div class="stage-container">
                        <div class="stage-text-container">
                            <bd-font class="stage-title" type="h2">
                                ${this.data.titleHighlight}
                                <span class="stage-title-highlight">${this.data.title}<span>
                            </bd-font>
                            ${this.data.description ? html`
                                <bd-font class="stage-desc" type="body1">
                                    ${this.data.description}
                                </bd-font>
                            ` : ''}
                        </div>
                        <div class="stage-cards-container">
                            ${this.data.cards.map((card) => html`
                                <research-product-promo-card
                                        class="stage-card"
                                        header="${card?.title}"
                                        description="${card?.description}"
                                        imgurl="${card?.image?.url}"
                                        static
                                        reversed
                                        show-description
                                        ?horizontal="${this._isTablet}"
                                >
                                    <bd-font class="stage-card-title" type="title" slot="title">
                                        <h4>${card?.title}</h4>
                                    </bd-font>
                                    <bd-font class="stage-card-description" type="body2" slot="description">
                                        <span>${card?.description}</span>
                                    </bd-font>
                                </research-product-promo-card>
                            `
        )}
                        </div>
                    </div>
        </research-section>` :
            ''}
        `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
        };
    }

    constructor() {
        super();
        this.data = {};
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
    }
}

window.customElements.define(researchStageSection.is, researchStageSection);
